import { useAuthStore } from '@auth/presentation/store/authStore';

export function getApiPrefix(): string {
  const role = useAuthStore.getState().user?.role;
  return role === 'superadmin' ? '/admin' : '/organizations';
}
